import { FC } from "react";

export interface CheckboxProps {
  /** Whether the checkbox is checked */
  checked: boolean;
}

export const Checkbox: FC<CheckboxProps> = ({ checked }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={16} height={17} fill="none">
      <path
        fill="#E3E5FA"
        d="M13 2.666a.833.833 0 0 1 .833.834v10a.833.833 0 0 1-.833.833H3a.833.833 0 0 1-.833-.833v-10A.833.833 0 0 1 3 2.666h10ZM3 1.833A1.667 1.667 0 0 0 1.333 3.5v10A1.667 1.667 0 0 0 3 15.166h10a1.667 1.667 0 0 0 1.667-1.666v-10A1.667 1.667 0 0 0 13 1.833H3Z"
      />
      {checked && (
        <path
          fill="#37CC8F"
          d="M10.474 5.975a.625.625 0 0 1 .893.875L8.04 11.008a.624.624 0 0 1-.9.017L4.936 8.82a.625.625 0 1 1 .884-.883L7.564 9.68l2.896-3.688a.106.106 0 0 1 .015-.018Z"
        />
      )}
    </svg>
  );
};
